import { observer } from 'mobx-react-lite';
import React from 'react';
import { Card, Col, Image } from 'react-bootstrap';
import { EnrollmentOrderItem } from '../order-selection/starter-kit-selection/model/EnrollmentOrderItem';

interface KitGridItemProps {
  item: EnrollmentOrderItem;
  showDetailLink?: boolean;
  customImage?: string;
  newSlMode?: boolean;
}

export const UnavailableItemCard = observer(function KitGridItem({
  item,
  showDetailLink = false,
  customImage,
  newSlMode = false
}: KitGridItemProps) {
  const image = customImage || item.imageUrl;
  console.log(item);
  return (
    <>
        {!newSlMode && 
        <Col key={item.partNumber} md={3} style={{ opacity: 0.33, marginBottom: '20px' }}>
          <Card style={{ minHeight: '340px' }}>
            <div className="text-left bg-secondary">
              <p className="text-white header-card-text m-1 h-56">{item.name}</p>
            </div>

            <Card.Body className="text-center">
              <span>
                <Image src={image} fluid />
              </span>
            </Card.Body>
          </Card>
        </Col>}

        {newSlMode &&
          <Col key={item.partNumber} md={3}>
            <Card className='sl-product-card sl-unavailable'>
                <div className='sl-product-image'>
                    <Image src={image} fluid />
                </div>
                <div className='sl-product-info'>
                  <p className='sl-product-title'>{item.name}</p>
                </div>
            </Card>
          </Col>}
    </>
  );
});
